import { render, staticRenderFns } from "./mention.vue?vue&type=template&id=42969578&scoped=true"
import script from "./mention.vue?vue&type=script&lang=js"
export * from "./mention.vue?vue&type=script&lang=js"
import style0 from "./mention.vue?vue&type=style&index=0&id=42969578&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42969578",
  null
  
)

export default component.exports